import { NgModule, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessoryFacade } from './+state/accessory.facade';
import { registerConstructionElementsConfigurations } from '@icc/construction-elements/types';

export function registerConstructionElementsConfigurator() {
    return () => {
        registerConstructionElementsConfigurations();
    };
}
import { AccessoriesComponent } from './accessories/accessories.component';
import { SharedModule } from '@icc/configurator/shared';
import { AccessoriesListPageComponent } from './accessories-list-page/accessories-list-page.component';
import { AccessoriesOptionsPageComponent } from './accessories-options-page/accessories-options-page.component';
import { AccessoriesColorsPageComponent } from './accessories-colors-page/accessories-colors-page.component';
import { ConfiguratorUiModule } from '@icc/configurator/ui';
import { ConfiguratorPagesModule } from '@icc/configurator/pages';
import { ColorsPageComponent } from './colors-page/colors-page.component';
import { WoodsPageComponent } from './woods-page/woods-page.component';
import { NewColorsService } from './colors/new-colors.service';
import { ProfileInfoComponent } from './profile-info/profile-info.component';
import { ProfileColorsService } from './profile-colors.service';
import { ProfilesColorsPageComponent } from './profiles-colors-page/profiles-colors-page.component';
import { ProfilesListPageComponent } from './profiles-list-page/profiles-list-page.component';
import { ColorsDefaultsService } from './colors/colors-defaults.service';
import { ColorMappingService } from './colors/colors-mapping.service';
import { ValidationService } from './validation.service';
import { MullionsService } from './mullions.service';
import { TimeLimitAccessoryService } from './time-limit/time-limit-accessory.service';
import { ColorRestrictionService } from './colors-restriction.service';

@NgModule({
    declarations: [
        AccessoriesComponent,
        AccessoriesListPageComponent,
        AccessoriesOptionsPageComponent,
        AccessoriesColorsPageComponent,
        ColorsPageComponent,
        WoodsPageComponent,
        ProfileInfoComponent,
        ProfilesColorsPageComponent,
        ProfilesListPageComponent,
    ],
    imports: [
        CommonModule,
        ConfiguratorUiModule,
        SharedModule,
        ConfiguratorPagesModule,
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = (registerConstructionElementsConfigurator)();
            return initializerFn();
        }),
        AccessoryFacade,
        NewColorsService,
        ColorRestrictionService,
        ProfileColorsService,
        ColorsDefaultsService,
        ColorMappingService,
        ValidationService,
        MullionsService,
        TimeLimitAccessoryService
    ],
    exports: [ColorsPageComponent, WoodsPageComponent, ProfileInfoComponent, ProfilesColorsPageComponent, ProfilesListPageComponent],
})
export class ConstructionElementsConfiguratorModule {}

export {AccessoriesComponent, AccessoriesListPageComponent, AccessoriesOptionsPageComponent, AccessoriesColorsPageComponent}
